import css from "styled-jsx/css";

const staticStyles = css`
  @import "src/common/styling/_mixins-scss/screen-size";
  @import "src/common/styling/_mixins-scss/rem";

  .CampaignForm {
    display: flex;
    flex-direction: column;

    .CampaignForm__content {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: rem(30px);

      .CampaignForm__caption {
        font-size: rem(24px);
        font-weight: 300;
        margin-bottom: rem(30px);
      }

      .CampaignForm__settings-block {
        display: flex;
        flex-direction: column;
        flex: 3;
        margin-right: rem(30px);
        padding: rem(30px 30px 10px);
      }

      .CampaignForm__active {
        display: flex;
        margin-top: rem(20px);

        span {
          margin-right: rem(20px);
        }
      }

      .CampaignForm__logo-block {
        display: flex;
        flex-direction: column;
        flex: 2;
        padding: rem(30px 30px 10px);

        .CampaignForm__description {
          margin: rem(10px 0 30px);
          font-size: rem(13px);
        }
      }

      @include respond-to(sm) {
        flex-direction: column;

        .CampaignForm__settings-block {
          margin-right: 0;
          margin-bottom: 30px;
        }
      }
    }

    .CampaignForm__buttons {
      display: flex;

      :global(.DefaultButton) {
        &:first-child {
          margin-right: rem(20px);
        }
      }
    }
  }
`;
const getDynamicStyles = ({ colors }) => {
  return css.global`
    .CampaignForm__settings-block,
    .CampaignForm__logo-block {
      background-color: ${colors.white.hex};
    }

    .CampaignForm__description {
      color: ${colors.gray.hex};
    }
  `;
};

export { staticStyles, getDynamicStyles };
